import store from "@/store";
import { Route } from "vue-router";

/* Per-Route router guards */
export default function requireAuthorization(to: Route, from: Route, next: any): void {
    const authorized = store.getters["authentication/authorize"](
        to.meta.permission
    );
    if (authorized) {
        next();
    } else {
        next(false);
    }
}
